/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
/* Added by Salvatore D @ Shopify Theme Support on March 6, 2019 */
var slideTransitionTime = parseInt($('.slideshow__slides').data('slideshow-transition-time'));
var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');
    
    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');
    
    var $slides = $('.slideshow__slide');
    
    var currentIndex = ($slides.index($slide) + 1) % $slides.length;
    
    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');
    
    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');
    
    var $dot = $('.slideshow__nav-dot--active')
                   .removeClass('slideshow__nav-dot--active');
    
    var $dots = $('.slideshow__nav-dot');
 
    $dots
      .eq(currentIndex)
      .trigger('click');
    
  }, slideTransitionTime)
  
};
 
sections.extend('slideshow', slideshowAutoExtension);




$(document).ready(function(){
  $("#request").click(function(){
    $(".request_overlay").css({'opacity':'1','transform':'translateY(0)'});
  });
  $(".request_overlay svg").click(function(){
    $(".request_overlay").css({'opacity':'0','transform':'translateY(100%)'});
  });
});
$(document).ready(function(){
  $("#request_quote").click(function(){
    $(".request_quote_overlay").css({'opacity':'1','transform':'translateY(0)'});
  });
  $(".request_quote_overlay svg").click(function(){
    $(".request_quote_overlay").css({'opacity':'0','transform':'translateY(100%)'});
  });
});


/* Added on February 5 2020 by Olawale O at Shopify */
$( document ).ready(function() {
  $('.drop-down-links-open-in-new-tab .navigation__sublink a, .navigation__sublink--third-level a, .drop-down-links-open-in-new-tab a').each(function() {
    $(this).attr('target', '_blank');
  });
});


/* End of change */